import React from "react"

import { InputWithLabel, Label, TextArea, ToggleButtonGroup } from "../../components/shared/Inputs"
import { Banner } from "../../components/shared/Layout"
import { UnderlinedLink } from "../../components/shared/Links"
import Typography from "../../components/shared/Typography"
import { usePractice } from "../../contexts/PracticeContext"

import LocationTimeZoneField from "./LocationTimeZoneField"

const VirtualLocationFields = ({ location, setLocation, validationErrors }) => {
  const { practice } = usePractice()

  const zoomActive =
    practice?.conferencingServices?.some((service) => service.provider === "zoom" && service.active) || false

  return (
    <>
      <ToggleButtonGroup
        options={[
          { label: "Video calls", value: "video" },
          { label: "Phone calls", value: "phone" }
        ]}
        onChange={(value) => setLocation({ ...location, virtualType: value })}
        value={location.virtualType || "video"}
      />

      <LocationTimeZoneField location={location} setLocation={setLocation} />

      {location.virtualType === "video" && (
        <>
          {!zoomActive ? (
            <>
              <div className="flex flex-col gap-2">
                <InputWithLabel
                  label="Virtual link"
                  value={location.virtualLink || ""}
                  explanatorySubtext="Ex: https://zoom.us/j/1234567890"
                  onChange={(e) => setLocation({ ...location, virtualLink: e.target.value })}
                  validationError={validationErrors.virtualLink}
                />
                <Banner type="info" className="text-sm">
                  You can add Zoom to generate unique links automatically.{" "}
                  <UnderlinedLink href="/portal/settings/conferencing">Click here to connect</UnderlinedLink>
                </Banner>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col gap-2">
                <Label>Virtual link</Label>
                <Banner type="info" className="text-sm">
                  Zoom is active and unique links will be generated automatically.{" "}
                  <UnderlinedLink href="/portal/settings/conferencing">
                    Click here to manage Zoom integration
                  </UnderlinedLink>
                </Banner>
              </div>
            </>
          )}
        </>
      )}
      <div>
        <Label htmlFor="virtual-instructions">Instructions on how to join</Label>
        <TextArea
          id="virtual-instructions"
          value={location.virtualInstructions || ""}
          onChange={(e) => setLocation({ ...location, virtualInstructions: e.target.value })}
          validationError={validationErrors.virtualInstructions}
        />
        <Typography variant="micro" as="div">
          Add simple instructions for how your clients will join these calls
        </Typography>
      </div>
    </>
  )
}

export default VirtualLocationFields
